import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { MyPromise } from '../interceptors/myPromise.service';

const BASE_URL = `${environment.baseEndpoint}/nom035`;

@Injectable({
  providedIn: 'root',
})
export class Nom035Service {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  getQuestions() {
    return this.myPromise.to(this.http.get(`${BASE_URL}/questions`));
  }

  getQuestionsByEmployeeId(employeeId: number) {
    return this.myPromise.to(this.http.get(`${BASE_URL}/questions/employee/${employeeId}`));
  }

  storeQuestionsEmployee(employeeId: number, stationId: string, questions: Array<object>) {
    return this.myPromise.to(this.http.post(`${BASE_URL}/questions/employee/${employeeId}`, { questions, stationId }));
  }

  getGroupsByCategory(category: string) {
    return this.myPromise.to(this.http.get(`${BASE_URL}/groups/category`, { params: {type: category} }));
  }

  // /station/:stationId/qualification/general
  getQualificationGeneralStation(stationId: string) {
    return this.myPromise.to(this.http.get(`${BASE_URL}/station/${stationId}/qualification/general`));
  }

}
